import { render, staticRenderFns } from "./GlobeLight.vue?vue&type=template&id=1ed09b1d"
import script from "./GlobeLight.vue?vue&type=script&lang=ts"
export * from "./GlobeLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports